import { formatDateToShortTime } from "@simplyk/common";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";

export interface AiAvailability {
  isAvailable: boolean;
  availableAt: string | null;
}

export const useAiUnavailableText = (availability: AiAvailability | undefined): string | null => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();

  if (!availability || availability.isAvailable) {
    return null;
  }
  if (!availability.availableAt) {
    return t("dashboard", "aiAvailability.unavailable");
  }
  const availableAt = new Date(availability.availableAt);
  const time = formatDateToShortTime(availableAt, locale);
  return availableAt.toDateString() === new Date().toDateString()
    ? t("dashboard", "aiAvailability.availableAgainAt", { time })
    : t("dashboard", "aiAvailability.availableAgainTomorrowAt", { time });
};
